module.exports = __webpack_public_path__ + "img/05.1c78dc5e.jpg";